var map = {
	"./en.json": "edd4",
	"./id.json": "210c",
	"./ja.json": "0423",
	"./km.json": "5153",
	"./ko.json": "dd11",
	"./th.json": "8680",
	"./zh-cn-tr.json": "9b6b8",
	"./zh-cn.json": "2c61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";